// Core
import {useState, useCallback, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Checkbox, 
  CheckboxGroup,
  Flex,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

function NotificationsCenterRow(props) {
  const { key, title, type, email, push, refetch, userData } = props;
  
  const [checkboxPush, setCheckboxPush] = useState(push);
  const [checkboxEmail, setCheckboxEmail] = useState(email);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const updateNotificationSettings = async () => {
      try {
        const response = await apiService.updateNotificationCenterOptions({ 
          type, 
          push: checkboxPush, 
          email: checkboxEmail 
        });

        if (response.statusCode === 200 || response.data === true) {
          refetch();
        }
      } catch (e) {}
    };

    updateNotificationSettings();
  }, [checkboxPush, checkboxEmail]);

  return (
    <Flex justifyContent="space-between" p="18px 0">
      <Text variant="title-md" fontWeight="500">{title}</Text>

      <Flex w="90px" gap="10px">
        <Stack spacing={5} direction='row' alignItems="center" justifyContent="center" width="100%">
            <Checkbox isChecked={checkboxPush} onChange={() => setCheckboxPush(!checkboxPush)}></Checkbox>
        </Stack>

        <Stack spacing={5} direction='row' alignItems="center" justifyContent="center" width="100%">
            <Checkbox isChecked={checkboxEmail} onChange={() => setCheckboxEmail(!checkboxEmail)}></Checkbox>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default NotificationsCenterRow;